import { FleekError } from './FleekError';

type DomainsNotFoundErrorOptions = object;

export class DomainsNotFoundError extends FleekError<DomainsNotFoundErrorOptions> {
  public name = 'DomainsNotFoundError';

  constructor() {
    super({});
  }

  toString = () => 'No domains found.';
}
